import styled from 'styled-components';
import { BodySmReg, BodyXsBold, SubtleShadow } from '@seed-health/tokens';

export const Panel = styled.div`
  /* 343px is the Figma-spec fixed width; no spacing token maps to this value */
  width: 343px;
  padding: var(--spacing-8);
  position: relative;
  isolation: isolate;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
  border-radius: var(--radius-md);
  box-shadow: ${SubtleShadow.offsetX} ${SubtleShadow.offsetY}
    ${SubtleShadow.blur} ${SubtleShadow.spread} ${SubtleShadow.color};
`;

/*
 * Luminosity overlay — Figma glass-effect panel background.
 * z-index: -1 keeps it behind in-flow rows; isolation: isolate on Panel
 * creates the stacking context that contains the blend.
 */
export const PanelOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: var(--fill-primary);
  mix-blend-mode: luminosity;
  pointer-events: none;
  border-radius: var(--radius-md);
`;

export const ItemRow = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: var(--spacing-40);
  padding: var(--spacing-8);
  gap: var(--spacing-8);
  border-radius: var(--radius-sm);
  background: ${({ $selected }) =>
    $selected ? 'var(--fill-secondary)' : 'var(--fill-primary)'};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: var(--fill-secondary);
  }

  &:active {
    opacity: var(--active);
  }

  &:focus-visible {
    outline: var(--stroke-default) solid var(--text-primary);
    outline-offset: -2px;
  }
`;

export const ItemLabel = styled.span`
  ${BodySmReg}
  color: var(--text-primary);
  flex: 1 0 0;
  min-width: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ItemTrailing = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  flex-shrink: 0;
`;

/* Per Figma the Deal frame is a square-cornered, unpadded highlight —
   the guidance-primary bg hugs the 16px icon + text with only the 4px gap. */
export const DealBadge = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  background: var(--guidance-primary);
  color: var(--text-primary);

  svg {
    fill: currentColor;
    color: currentColor;
  }
`;

export const DealText = styled.span`
  ${BodyXsBold}
  display: block;
  text-align: right;
  color: var(--text-primary);
`;

export const CheckmarkSlot = styled.span<{ $visible: boolean }>`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
